<template>
  <b-form-group label="Cooperado" :state="state('selecaoCooperado')">
    <multiselect
      v-model="selecaoCooperado"
      :options="cooperadoLkp"
      label="name"
      track-by="name"
      placeholder="Selecione"
      :allowEmpty="false"
      :taggable="false"
      select-label=""
      @input="emitirCooperado"
      invalid-feedback="Campo obrigatório"
      :disabled="disabledCooperado"
    >
      <span slot="noOptions">Nenhum Cooperado disponível</span>
    </multiselect>
  </b-form-group>
</template>

<script>
import Multiselect       from "vue-multiselect";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";
import { required }      from "vuelidate/lib/validators";

export default {
  mixins    : [clienteRuralMixin],
  components: {Multiselect},
  data() {
    return {
      selecaoCooperado : null,
      disabledCooperado: false,
      cooperadoLkp     : [],
      cdPessoa         : null,
      sqUsuario        : null,
    };
  },
  async created() {
    await this.buscarDados();
  },
  methods: {
    async buscarDados(){
      await this.getNomeRazaoUsuario();
      await this.buscarLkpCooperado();
      await this.verificarCooperado();

      if (this.cooperadoLkp.length === 1) {
        this.disabledCooperado = true;
      }

      this.$emit("cooperadoSelecionado", this.selecaoCooperado);
    },
    async getNomeRazaoUsuario() {
      try {
        this.cdPessoa  = this.$store.state.me?.cd_pessoa;
        this.sqUsuario = this.$store.state.me?.sq_usuario;
      } catch {
        this.logoutUser();
      }
    },
    async verificarCooperado() {
      if (this.cooperadoLkp.length > 0) {
        const cooperadoEncontrado = this.cooperadoLkp.find(cooperado => cooperado.value === this.cdPessoa);
          
        if (cooperadoEncontrado) {
          this.selecaoCooperado = cooperadoEncontrado;
        } else {
          this.selecaoCooperado = null;
        }
      } else {
        this.selecaoCooperado = null;
      }

      return;
    },
    state(param) {
      if (this.submit) {
        return !this.$v[param].$invalid;
      } else {
        return null;
      }
    },
    emitirCooperado() {
      this.$emit("cooperadoSelecionado", this.selecaoCooperado);
    }
  },
  validations: {
    selecaoCooperado: { required, },
  }
};
</script>